import { Component, OnInit } from '@angular/core';
import {UserService} from '../../services/user.service';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import { Title } from '@angular/platform-browser';
import {MetatagService} from '../../services/metatag.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html'
})
export class SignupComponent implements OnInit {
    public form: FormGroup;
    public success: boolean = false;
    public aanmelden: Object = null;
    public paymentapproval: Object = null;
    public abonnementen: Array<String>;

    constructor(private titleService: Title, private userService: UserService, private fb: FormBuilder,
                private metatagService:MetatagService) {
        this.form = fb.group({
            company: ['', Validators.required],
            name: ['', Validators.required],
            address: ['', Validators.required],
            emailAddress: ['', Validators.compose([Validators.required,Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)])],
            password: ['', Validators.compose([Validators.required,Validators.minLength(8)])],
            paymentplan: ['', Validators.required],
            agree1: ['', Validators.required],
            agree2: ['']
        });
    }

    ngOnInit() {
        this.titleService.setTitle('Aanmelden bij Dermabase');
        this.metatagService.setMetaTags('', '');

        this.userService.getSignupValues().subscribe((res) => {
            this.aanmelden = res.aanmelden;
            this.paymentapproval = res.paymentapproval;
            this.abonnementen = res.abonnementen;
        }, (error) => {
            console.log('error getSignupValues');
        });
    }

    submit() {
        if (this.form.controls.password.status === 'INVALID') {
            alert('Het wachtwoord moet minimaal 8 karakters lang zijn.');
        } else if (!this.form.valid) {
            //TODO: create better error handling?
            alert('Vul alle velden correct in');
        } else {
            let isAgreed: boolean = false;
            if (this.form.value.agree2 === true) {
                isAgreed = !isAgreed;
            }

            this.userService.register(
                this.form.value.emailAddress,
                this.form.value.emailAddress,
                this.form.value.password,
                this.form.value.company,
                this.form.value.name,
                this.form.value.address,
                this.form.value.paymentplan,
                isAgreed
            ).subscribe((res) => {
                this.success = true;
            },(err) => {
                alert(err);
            });
        }
        return false;
    }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/signup/signup.component.ts